import baseStyled, {ThemedStyledInterface} from 'styled-components';
import {ThemeDark} from '@zappar/foundry-react-components/lib/theme';

export const styled = baseStyled as ThemedStyledInterface<typeof ThemeDark>;
